module.exports = __webpack_public_path__ + "img/selected3-min.12edf20d.png";